<div class="dialog">

  <h1 mat-dialog-title>
    {{title}}
  </h1>

  <div mat-dialog-content>
    <input
      class="name-input"
      type="text"
      [(ngModel)]="value"
      (keydown.enter)="onConfirm()"
      autofocus />
  </div>

  <div class="ftbtn-gr" mat-dialog-actions>
    <button class="ftbtn" mat-raised-button color="primary" [disabled]="!value || !value.trim()" (click)="onConfirm()">{{confirmLabel}}</button>
    <button class="ftbtn" mat-button (click)="onCancel()">Cancel</button>
  </div>
</div>
